import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import onClickOutside from 'react-onclickoutside';
import without from 'lodash/without';

import colors from '../../styling/colors';
import { updateCountryCodeAndCurrency } from '../../redux/env';
import { openCurrencyModal, closeCurrencyModal } from '../../redux/modals';
import withClickTracking from '../../tracking/withClickTracking';

const Currency = styled.div`
  position: relative;
`;

const CurrencyWrapper = styled.div`
  width: 64px;
`;

const Current = styled.div`
  cursor: pointer;
  color: ${colors('boulder')};
  cursor: pointer;
  font-size: 12px;

  ::after {
    border-color: ${colors('boulder')};
    border-style: solid;
    border-width: 0 1px 1px 0;
    content: '';
    height: 5px;
    left: 38px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg);
    width: 5px;
  }
`;

const Dropdown = styled.div`
  background-color: ${colors('white')};
  border: solid 1px ${colors('alto')};
  bottom: -22px;
  cursor: pointer;
  height: 96px;
  left: -9px;
  position: absolute;
  width: 66px;
`;

const Option = styled.div`
  align-items: center;
  border-bottom: solid 1px ${colors('alto')};
  display: flex;
  height: 32px;
  width: 64px;

  &:last-child {
    border: none;
  }
`;

const TrackedOption = withClickTracking(Option);

const OptionText = styled.div`
  text-align: left;
  padding: 0 8px;
`;
// prettier-ignore
const countriesToCurrency = {
  'US': '$USD',
  'AU': '$AUD',
  'GB': '£GBP'
};

// prettier-ignore
const currenciesToCountry = {
  '$USD': 'US',
  '$AUD': 'AU',
  '£GBP': 'GB'
};

// prettier-ignore
const currenciesWithoutSymbol = {
  '$USD': 'USD',
  '$AUD': 'AUD',
  '£GBP': 'GBP'
};

const allCurrencies = ['$AUD', '£GBP', '$USD'];

class CurrencyDropdown extends Component {
  static propTypes = {
    preferredCountryCode: PropTypes.string,
    openCurrencyModal: PropTypes.func,
    closeCurrencyModal: PropTypes.func,
    updateCountryCodeAndCurrency: PropTypes.func,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  handleClickOutside = () => this.closeDropdown();

  closeDropdown = () => {
    this.props.disableOnClickOutside();
    // This can trigger on other clicks, like when a user clicks within the CategoryNav
    if (this.state.isOpen) {
      this.props.closeCurrencyModal();
    }
    this.setState({ isOpen: false });
  };

  toggleDropdown = () => {
    if (this.state.isOpen) {
      this.closeDropdown();
    } else {
      this.props.enableOnClickOutside();
      this.props.openCurrencyModal();
      this.setState({ isOpen: true });
    }
  };

  getOptions = current => {
    let sorted = without(allCurrencies, current);
    sorted.push(current);
    return sorted;
  };

  closedContent = currency => {
    return <Current onClick={this.toggleDropdown}>{currency}</Current>;
  };

  handleCurrencyChange = (currentCurrency, selectedCurrency) => {
    if (currentCurrency !== selectedCurrency) {
      this.props.updateCountryCodeAndCurrency(
        currenciesToCountry[selectedCurrency],
        currenciesWithoutSymbol[selectedCurrency],
      );
    }

    this.closeDropdown();
  };

  openContent = currentCurrency => {
    return (
      <Dropdown>
        {this.getOptions(currentCurrency).map((currency, index) => (
          <TrackedOption
            key={index}
            identifier={currenciesWithoutSymbol[currency]}
            onClick={() => this.handleCurrencyChange(currentCurrency, currency)}
          >
            <OptionText>{currency}</OptionText>
          </TrackedOption>
        ))}
      </Dropdown>
    );
  };

  render() {
    const { isOpen } = this.state;
    const { preferredCountryCode } = this.props;
    let currentCurrency = countriesToCurrency[preferredCountryCode];

    return (
      <CurrencyWrapper>
        <Currency>
          {isOpen
            ? this.openContent(currentCurrency)
            : this.closedContent(currentCurrency)}
        </Currency>
      </CurrencyWrapper>
    );
  }
}

const mapStateToProps = ({ env: { preferredCountryCode = 'US' } }) => {
  return {
    preferredCountryCode,
  };
};

const mapDispatchToProps = {
  updateCountryCodeAndCurrency,
  openCurrencyModal,
  closeCurrencyModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(onClickOutside(CurrencyDropdown));
